import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Label = ({ name, required, children }) => {
  const labelClass = classnames({
    'label-required': required,
  });

  if (children) {
    return <label htmlFor={name} className={labelClass}>{children}</label>;
  }
  return null;
};

Label.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  children: PropTypes.string,
};

export default Label;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/Label.js